/* eslint-disable @typescript-eslint/naming-convention */
import { Icon, Tooltip } from '@dev-spendesk/grapes';
import cx from 'classnames';
import { type MonetaryValue, add } from 'ezmoney';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { formatMonetaryValue } from 'src/core/utils/monetaryValue';

import {
  type BudgetBreakdown,
  getExceededAmount,
  getSpentAmount,
  hasExceededAmounts,
} from '../../models/breakdown';

type Props = {
  amount: MonetaryValue;
  breakdown: BudgetBreakdown;
  hint?: string;
};

export const BudgetAmountEstimation = ({ breakdown, amount, hint }: Props) => {
  const { t } = useTranslation('global');

  const isExceeded = hasExceededAmounts(breakdown);
  const middleText = isExceeded
    ? t('budget.gauge.on')
    : t('budget.gauge.impactedOn');
  const sum = isExceeded
    ? add(amount, getExceededAmount(breakdown))
    : getSpentAmount(breakdown, false);

  return (
    <div className="text-content-primary body-l flex items-baseline gap-4">
      <span
        className={cx('text-content-primary body-xl', {
          'text-content-warning-default': isExceeded,
        })}
      >
        {formatMonetaryValue(sum)}
      </span>
      <span className="text-content-secondary-bg-primary body-l">
        {middleText}
      </span>
      <span className="text-content-secondary-bg-primary body-l">
        {formatMonetaryValue(amount)}
      </span>
      {hint && (
        <Tooltip triggerAsChild content={hint}>
          <Icon className="ml-8 self-center" name="circle-information" />
        </Tooltip>
      )}
    </div>
  );
};
